import { message } from "antd";

interface ToasterProps {
  content?: string;
  type?: string;
  duration?: number;
}

export const UNAUTHORIZED_ERROR_MESSAGE = "You are not authorized to process this request." as const;

export const Toastify = (type: string, content = "") => {
  switch (type) {
    case "success":
      message.success({
        className: "toaster toaster-success",
        content: content
      });
      break;
    case "error":
      message.error({
        className: "toaster toaster-error",
        content: content
      });
      break;
    case "info":
      message.info({
        className: "toaster toaster-info",
        content: content
      });
      break;
    case "warning":
      message.warning({
        className: "toaster toaster-warning",
        content: content
      });
      break;
  }
};

export const toastGetError = (content?: string) => {
  if (!content) return;
  if (content === UNAUTHORIZED_ERROR_MESSAGE) return;
  Toastify("error", content);
};

function Toaster(props: ToasterProps) {
  return Toastify(props.type || "info", props.content);
}
export default Toaster;
